import React, { useEffect, useState, createContext, useContext } from 'react';
import { request } from 'utils/api';
import { PUBLIC_TOKEN } from 'utils/env';
import useQuery from 'utils/hooks/useQuery';

const FeaturesContext = createContext({});

export function FeaturesProvider({ children }) {
  const query = useQuery();
  const [features, setFeatures] = useState({});

  useEffect(() => {
    async function getFeatures() {
      const { content } = await request({
        method: 'GET',
        path: `/v1/features`,
        headers: { Authorization: `Basic ${PUBLIC_TOKEN}` },
      });

      if (!content) return;

      const featuresObject = {};
      for (const {
        key,
        splitPercentage,
        gaTagSuffix,
        formVariant,
      } of content) {
        // Split percentage is the possibility of enabling the feature
        const forced = Number(query.get(formVariant) ?? undefined);
        if (forced === 0) {
          continue;
        }

        const enable = forced || Math.random() * 100 < splitPercentage;
        if (enable) {
          featuresObject[key] = { gaTagSuffix, formVariant };
        }
      }

      setFeatures(featuresObject);
    }

    getFeatures();
  }, []);

  return (
    <FeaturesContext.Provider value={features}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeaturesContext);
}

export function useFormVariant() {
  const formVariants = Object.entries(useFeatures()).map((f) => f[1].formVariant).sort();

  if (formVariants.length == 0) {
    return "control"
  }

  return formVariants.join(", ");
}